import React from "react";

const SmallLoader = () => {
  return <div className="spinner"></div>;
};

export default SmallLoader;
